<app-documentlist [Request]="request"
    [SortingAllowed]="!workflowData || workflowData.allowSorting" [placeholders]="!workflowData || workflowData.placeholders"
    [showDocument]="!workflowData || workflowData.allowRendering"
    [allowAddDocuments]="!workflowData || workflowData.allowAddDocuments" [workflowId]="workflowId"
    (DocumentChange)="DocumentChange($event)" (PlaceholderDeleted)="PlaceHolderDeleted($event)"
    (DocumentDeleted)="DocumentDeleted($event)" (DocumentChangeOrder)="DocumentChangeOrder($event)"
    (OnFileSelected)="OnFileSelected($event)" (OnFileSelectedWorkflow)="OnFileSelectedWorkflow($event)"
    (getRequest)="GetRequest($event)" (openViewer)="openViewerEvent($event)"
    (UploadCloudDocuments)="uploadCloudDocuments($event)"
    (loadThumbnail)="loadThumbnail($event)">
</app-documentlist>

<ng-container
    *ngIf="!workflowData || !workflowData.placeholders || workflowData.placeholders.length===0 || workflowData.allowAddDocuments">
    <app-adddocumentsdropzone class="d-none d-lg-block" [Request]="request"
        [MaxDocumentAmount]="!workflowData || workflowData.maxDocumentAmount" (OnFileSelected)="OnFileSelected($event)"
        (getRequest)="GetRequest($event)" (UploadCloudDocuments)="uploadCloudDocuments($event)">
    </app-adddocumentsdropzone>
</ng-container>

<app-adddocumentsdropzone class="d-block d-lg-none" [Request]="request"
    [MaxDocumentAmount]="!workflowData || workflowData.maxDocumentAmount" (OnFileSelected)="OnFileSelected($event)"
    (getRequest)="GetRequest($event)" (UploadCloudDocuments)="uploadCloudDocuments($event)">
</app-adddocumentsdropzone>